import React, { useCallback, useState } from 'react';
import arrowBack from "../assets/images/arrow_back.svg";
import "../css/DispositionPage.css";
import GreenTick from "../assets/images/greenTickSmall.png";
import { debounce } from 'lodash';

function DispositionPage({
  destinationName,
  destinationNumber,
  callStatus,
  timer,
  dispositions,
  disposition,
  showDispositionUpdatedMessage,
  goToBack,
  updateDisposition,
  callId,
  callComment,
  setCallComment
}) {

  const [updatedText, setUpdatedText] = useState("Disposition Updated");

  const debouncedUpdateComment = useCallback(
    debounce((id, disp, comm) => updateDisposition(id, disp, comm), 1000),
    []
  );

  return (
    <div className='DispositionPage'>
      <div className='DispositionHeader'>
        <div>
          <img
            style={{ cursor: 'pointer', marginTop: '5px' }}
            src={arrowBack}
            width={'16px'}
            height={'16px'}
            onClick={goToBack}
          />
        </div>
        <div>Call Notes</div>
      </div>
      <div className='DispositionBody'>

        <div className='SelectDispositionSection'>
          <div className='SelectDispositionTitle'>Select Disposition</div>
          <select
            className='SelectDispositionDropDown'
            onChange={(e) => {
              setUpdatedText("Disposition Updated");
              updateDisposition(callId, e.target.value, "");
            }}
          >
            <option value="" selected={true}>Select disposition</option>
            {dispositions?.map((i) => (
              <option key={i._id} value={i.dispositon} selected={disposition === i.dispositon ? true : false}>
                {i.dispositon}
              </option>
            ))}
          </select>
        </div>

        <div className='CommentSection'>
          <div className='CallCommentTitle'>Comments</div>
          <textarea
            className="CallCommentArea"
            value={callComment}
            disabled={!disposition}
            placeholder="Enter comments..."
            onChange={(e) => {
              setCallComment(e.target.value);
              setUpdatedText("Comments Updated");
              debouncedUpdateComment(callId, disposition, e.target.value);
            }}
          />
        </div>

        {
          showDispositionUpdatedMessage ?
            <label
              className='Disposition-updated'>
              <img src={GreenTick} alt='disposition' />&nbsp; {updatedText}
            </label>
            : null
        }
      </div>
      <div className='DispositionFooter'>
        <div style={{ textAlign: 'left' }}>
          <div className="destinationName">
            {' '}
            {destinationName || 'Single Call'}
          </div>
          <div className="destinationNumber">{`+91 ${destinationNumber}`}</div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div className="timer">
            {timer || "00:00"}
          </div>
          <div
            className="callStatus"
            style={{ color: callStatus === "Ended" ? "red" : 'green' }}
          >
            {callStatus || "-"}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DispositionPage